export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_ERROR = 'PASSWORD_RESET_ERROR';
export const PASSWORD_SET = 'PASSWORD_SET';
export const PASSWORD_SET_SUCCESS = 'PASSWORD_SET_SUCCESS';
export const PASSWORD_SET_ERROR = 'PASSWORD_SET_ERROR';
export const PASSWORD_SET_FORM_ERROR = 'PASSWORD_SET_FORM_ERROR';
export const GET_ACCOUNT_EMAIL = 'GET_ACCOUNT_EMAIL';
export const GET_ACCOUNT_EMAIL_SUCCESS = 'GET_ACCOUNT_EMAIL_SUCCESS';
export const GET_ACCOUNT_EMAIL_ERROR = 'GET_ACCOUNT_EMAIL_ERROR';
export const FORGOT_PASSWORD_ANALYTICS = 'FORGOT_PASSWORD_ANALYTICS';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const RESET_PASSWORD_SLIDER_STATE = 'RESET_PASSWORD_SLIDER_STATE';
export const POST_REQUEST_OTP_TO_RESET_PASSWORD = 'POST_REQUEST_OTP_TO_RESET_PASSWORD';
export const POST_REQUEST_OTP_TO_RESET_PASSWORD_SUCCESS =
    'POST_REQUEST_OTP_TO_RESET_PASSWORD_SUCCESS';
export const POST_REQUEST_OTP_TO_RESET_PASSWORD_ERROR = 'POST_REQUEST_OTP_TO_RESET_PASSWORD_ERROR';
export const VERIFY_OTP_TO_RESET_PASSWORD = 'VERIFY_OTP_TO_RESET_PASSWORD';
export const VERIFY_OTP_TO_RESET_PASSWORD_SUCCESS = 'VERIFY_OTP_TO_RESET_PASSWORD_SUCCESS';
export const VERIFY_OTP_TO_RESET_PASSWORD_ERROR = 'VERIFY_OTP_TO_RESET_PASSWORD_ERROR';
export const SET_NEW_PASSWORD_USING_PHONE_NUMBER = 'SET_NEW_PASSWORD_USING_PHONE_NUMBER';
export const SET_NEW_PASSWORD_USING_PHONE_NUMBER_SUCCESS =
    'SET_NEW_PASSWORD_USING_PHONE_NUMBER_SUCCESS';
export const SET_NEW_PASSWORD_USING_PHONE_NUMBER_ERROR =
    'SET_NEW_PASSWORD_USING_PHONE_NUMBER_ERROR';
export const ENABLE_RESEND_OTP_TO_RESET_PASSWORD = 'ENABLE_RESEND_OTP_TO_RESET_PASSWORD';
export const PASSWORD_RESET_BY_PHONE_INITIATED = 'PASSWORD_RESET_BY_PHONE_INITIATED';
